export default {
  title: 'merchant settlement',
  steps: {
    one: 'Choose a wallet',
    two: 'google Validator',
    three: 'verify code'
  },
  label: {
    bankId: 'Withdrawal bank id',
    googleDynamicCaptcha: 'Google verification code',
    payPass: 'Payment password',
    walletType: 'Wallet type',
    withdrawAmount: 'Withdrawal Amount',
    amountTotal: 'Total balance',
    blanceAmount: 'remaining balance'
  },
  rules: {
    bankId: {
      required: 'The withdrawal bank id must be selected'
    },
    googleDynamicCaptcha: {
      required: 'Google verification code cannot be empty',
      type: 'Google verification code must be a number',
      max: 'Google verification code is 6 digits'
    },
    payPass: {
      required: 'Payment password cannot be empty'
    },
    walletType: {
      required: 'Wallet type must be selected'
    },
    withdrawAmount: {
      required: 'withdrawal amount cannot be empty',
      type: 'The withdrawal amount must be a number',
      min: 'The withdrawal amount must be greater than 1000',
      max: 'The withdrawal amount cannot be greater than the balance'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/merchantdeposit.js